import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { AddOrEditMembershipPlansComponent } from "src/app/admin-panel/components/business/membership-plans/add-or-edit-membership-plans/add-or-edit-membership-plans.component";
import { DeleteMembershipPlansComponent } from "src/app/admin-panel/components/business/membership-plans/delete-membership-plans/delete-membership-plans.component";
import { MembershipPlansComponent } from "src/app/admin-panel/components/business/membership-plans/membership-plans.component";
import { AddOrEditPaymentProcessorsComponent } from "src/app/admin-panel/components/business/payment-processors/add-or-edit-payment-processors/add-or-edit-payment-processors.component";
import { DeletePaymentProcessorsComponent } from "src/app/admin-panel/components/business/payment-processors/delete-payment-processors/delete-payment-processors.component";
import { DetailsPaymentProcessorsComponent } from "src/app/admin-panel/components/business/payment-processors/details-payment-processors/details-payment-processors.component";
import { PaymentProcessorsComponent } from "src/app/admin-panel/components/business/payment-processors/payment-processors.component";
import { SuspendPaymentProcessorsComponent } from "src/app/admin-panel/components/business/payment-processors/suspend-payment-processors/suspend-payment-processors.component";
import { ArchivePaymentComponent } from "src/app/admin-panel/components/business/payments/archive-payment/archive-payment.component";
import { DetailsPaymentComponent } from "src/app/admin-panel/components/business/payments/details-payment/details-payment.component";
import { PaymentsComponent } from "src/app/admin-panel/components/business/payments/payments.component";
import { AppUsersComponent } from "src/app/admin-panel/components/members/app-users/app-users.component";
import { ArchiveAppUserComponent } from "src/app/admin-panel/components/members/app-users/archive-app-user/archive-app-user.component";
import { DetailsAppUserComponent } from "src/app/admin-panel/components/members/app-users/details-app-user/details-app-user.component";
import { ArchiveMemberCompanyComponent } from "src/app/admin-panel/components/members/member-companies/archive-member-company/archive-member-company.component";
import { DetailsMemberCompanyComponent } from "src/app/admin-panel/components/members/member-companies/details-member-company/details-member-company.component";
import { MemberCompaniesComponent } from "src/app/admin-panel/components/members/member-companies/member-companies.component";
import { AddOrEditGeneralManagerComponent } from "src/app/admin-panel/components/system-profiles/general-manager/add-or-edit-general-manager/add-or-edit-general-manager.component";
import { GeneralManagerComponent } from "src/app/admin-panel/components/system-profiles/general-manager/general-manager.component";
import { DeleteGeneralManagerComponent } from "src/app/admin-panel/components/system-profiles/general-manager/delete-general-manager/delete-general-manager.component";
import { MyProfileComponent } from "src/app/admin-panel/components/system-profiles/my-profile/my-profile.component";
import { AddOrEditSuperAdministratorComponent } from "src/app/admin-panel/components/system-profiles/super-administrator/add-or-edit-super-administrator/add-or-edit-super-administrator.component";
import { DeleteSuperAdministratorComponent } from "src/app/admin-panel/components/system-profiles/super-administrator/delete-super-administrator/delete-super-administrator.component";
import { SuperAdministratorComponent } from "src/app/admin-panel/components/system-profiles/super-administrator/super-administrator.component";
import { AddOrEditTechSupportComponent } from "src/app/admin-panel/components/system-profiles/tech-support/add-or-edit-tech-support/add-or-edit-tech-support.component";
import { DeleteTechSupportComponent } from "src/app/admin-panel/components/system-profiles/tech-support/delete-tech-support/delete-tech-support.component";
import { TechSupportComponent } from "src/app/admin-panel/components/system-profiles/tech-support/tech-support.component";
import { PrimeNgModule } from "../prime-ng/prime-ng.module";
import { AdminRoutingModule } from "./admin-routing.module";
import {
  AddOrEditSpecialOfferComponent
} from "src/app/admin-panel/components/business/membership-plans/add-or-edit-special-offer/add-or-edit-special-offer.component";

// Http Loader for ngx-translate
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    MyProfileComponent,
    GeneralManagerComponent,
    AddOrEditGeneralManagerComponent,
    DeleteGeneralManagerComponent,
    SuperAdministratorComponent,
    AddOrEditSuperAdministratorComponent,
    DeleteSuperAdministratorComponent,
    TechSupportComponent,
    MembershipPlansComponent,
    AddOrEditMembershipPlansComponent,
    DeleteMembershipPlansComponent,
    PaymentProcessorsComponent,
    PaymentsComponent,
    MemberCompaniesComponent,
    AppUsersComponent,
    AddOrEditTechSupportComponent,
    DeleteTechSupportComponent,
    DetailsAppUserComponent,
    ArchiveAppUserComponent,
    ArchiveMemberCompanyComponent,
    DetailsMemberCompanyComponent,
    DetailsPaymentComponent,
    ArchivePaymentComponent,
    AddOrEditPaymentProcessorsComponent,
    DetailsPaymentProcessorsComponent,
    SuspendPaymentProcessorsComponent,
    DeletePaymentProcessorsComponent,
    AddOrEditSpecialOfferComponent,
  ],
  imports: [
    AdminRoutingModule,
    PrimeNgModule,
    CommonModule,
    NgbModule,
    BrowserModule,
    FormsModule,
    InfiniteScrollModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: createTranslateLoader
      }
    }),

  ],
  exports: []
})

export class AdminModule { }
